window.Products.Clothing.BabyLeggings = function() {
};
window.Products.Clothing.BabyLeggings.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.BabyLeggings.id = 27;
window.Products.Clothing.BabyLeggings.slug = 'baby-leggings';
window.Products.Clothing.BabyLeggings.has_3d = true;
window.Products.Clothing.BabyLeggings.has_subproducts = true;
window.Products.Clothing.BabyLeggings.dpi = 150;
window.Products.Clothing.BabyLeggings.camera_fixed = -1.2;

window.Products.Clothing.BabyLeggings.prototype.set3dProperties = function(modelViewer) {
    modelViewer.object.position.y = 0.03;
    this.updateThreeTexture(modelViewer);
    modelViewer.initalCameraPosition.z = this.parent.static.camera_fixed;
    if(!modelViewer.inlab){
        modelViewer.setFixedView('front');
        modelViewer.enableAutoRotate(0.5);
        modelViewer.camera.position.z = 0.5;
    }
};

window.Products.Clothing.BabyLeggings.prototype.setThreeControls = function(controls) {
    controls.minDistance = 1.15;
    controls.maxDistance = 1.6;
};

window.Products.Clothing.BabyLeggings.prototype.updateThreeTexture = function(modelViewer) {
    modelViewer.object.children[0].material.map = modelViewer.texture;
    modelViewer.object.children[1].material.map = modelViewer.texture;
    modelViewer.object.children[0].material.bumpScale = 0.0005;
    modelViewer.object.children[1].material.bumpScale = 0.0005;
};